//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteScriptCodeInputItem } from './WebsiteScriptCodeInputItem';
import { WebsitePageInputItem } from './WebsitePageInputItem';
import { WebsiteSocialLinksLocation, WebsiteTemplate, WebsiteHostingType } from './Enums';

export class WebsiteInputItem extends ItemBase {
    Url: string | null = null;
    Title: string | null = null;
    AccentColor: string | null = null;
    BackgroundColor: string | null = null;
    HeaderColor: string | null = null;
    FooterColor: string | null = null;
    HeadingFontFamily: string | null = null;
    BodyFontFamily: string | null = null;
    ScriptCodes: WebsiteScriptCodeInputItem[] = [];
    FacebookUrl: string | null = null;
    TwitterUrl: string | null = null;
    InstagramUrl: string | null = null;
    LinkedInUrl: string | null = null;
    YouTubeUrl: string | null = null;
    TikTokUrl: string | null = null;
    SocialLinksLocation: WebsiteSocialLinksLocation = WebsiteSocialLinksLocation.All;
    HeaderLogoMediaLibraryItemID: string | null = null;
    Template: WebsiteTemplate | null = null;
    HostingType: WebsiteHostingType = WebsiteHostingType.ExternallyHosted;
    WebsitePages: WebsitePageInputItem[] = [];

    constructor(initializer?: Partial<WebsiteInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteInputItem";
}
